import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useSWRConfig } from 'swr'
import PageTitle from '../../components/UI/PageTitle'
import UserForm from '../../components/Forms/UserForm'
import { useAuthContext } from '../../context/auth/auth'
import { UserTypes } from '../../interfaces/user'
import axios from '../../services/api'

const EditUser = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const { mutate } = useSWRConfig()
  const navigate = useNavigate()

  const { token } = useAuthContext()
  const users: UserTypes[] = useOutletContext()

  const { id } = useParams()
  const user = users.find(user => user.id?.toString() === id)

  const onSubmit = async (values: UserTypes) => {
    const userData = {
      username: values.username,
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      user_type: values.user_type,
    }

    try {
      setIsLoading(true)
      const response = await axios.patch(`/auth/user/${id}/`, userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        mutate('users')
        navigate('/admin/users')
        toast.success(t('userHasBeenUpdated'))
      }
    } catch (error: any) {
      if (error.response.data.data[0].includes('email')) {
        toast.error(t('aUserWithThisEmailAlreadyExists'))
      } else if (error.response.data.data[0].includes('username')) {
        toast.error(t('aUserWithThisUsernameAlreadyExists'))
      } else {
        toast.error(t('failedToUpdateUser'))
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => () => setIsLoading(false), [])

  useEffect(() => {
    document.title = `${t('editUser')} - ReportAll`
  }, [t])

  return (
    <>
      <PageTitle title={t('editUser')} />
      <UserForm onSubmit={onSubmit} user={user} isLoading={isLoading} />
    </>
  )
}

export default EditUser
